import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../endpoints";
import * as walletActions from "../actions/account_wallet_actions";
import * as walletTypes from "../types/account_wallet_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getWalletInfo(action) {
  try {  
    const res = yield call(api.get, `${endpoints.SUPER_ADMIN_WALLET_INFO}/${action.payload.id}`, action.payload.data);
    if (res.status === 200) {
      yield put(walletActions.getWalletInfoSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(walletActions.getWalletInfoError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(walletActions.getWalletInfoError(e));
  }
}

function* addWalletBalance(action) {
  try {
    const res = yield call(api.patch, `${endpoints.SUPER_ADMIN_WALLET_CREDIT}`, action.payload.data);
    if (res.status === 200) {
      yield put(walletActions.addWalletBalanceSuccess(res.data));
      yield put(walletActions.getWalletInfoRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(walletActions.addWalletBalanceError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(walletActions.addWalletBalanceError(e));
  }
}

function* deductWalletBalance(action) {
  try {
    const res = yield call(api.patch, `${endpoints.SUPER_ADMIN_WALLET_DEBIT}`, action.payload.data);
    if (res.status === 200) {
      yield put(walletActions.deductWalletBalanceSuccess(res.data));
      yield put(walletActions.getWalletInfoRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(walletActions.deductWalletBalanceError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(walletActions.deductWalletBalanceError(e));
  }
}

function* getAccountBillingDetails(action) {
  try {  
    const res = yield call(api.get, `${endpoints.SUPER_ADMIN_ACCOUNT_BILLING_DETAILS}/${action.payload.id}`);
    if (res.status === 200) {
      yield put(walletActions.getAccountBillingDetailsSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(walletActions.getAccountBillingDetailsError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(walletActions.getAccountBillingDetailsError(e));
  }
}

export default function* walletSaga() {
  yield takeLatest(walletTypes.getWalletInfo.GET_WALLET_INFO_REQUEST, getWalletInfo);
  yield takeLatest(walletTypes.addWalletBalance.ADD_WALLET_BALANCE_REQUEST, addWalletBalance);
  yield takeLatest(walletTypes.deductWalletBalance.DEDUCT_WALLET_BALANCE_REQUEST, deductWalletBalance);
  yield takeLatest(walletTypes.getAccountBillingDetails.GET_ACCOUNT_BILLING_DETAILS_REQUEST , getAccountBillingDetails)
}
